import { useMemo } from 'react'
import { atom, useRecoilState } from 'recoil'
import { useParams } from 'react-router-dom'

const countItemsState = atom({
  key: 'RanCountItems',
  default: 0
})

const itemsSelectedState = atom({
  key: 'RanItemsSelected',
  default: []
})

const lastItemCheckedState = atom({
  key: 'RanLastItemChecked',
  default: null
})

const filtersState = atom({
  key: 'RanFilters',
  default: {
    created_start_at: '',
    created_end_at: '',
    verbatim: ''
  }
})

const sortState = atom({
  key: 'RanSort',
  default: {
    by: 'created_at',
    direction: 'desc'
  }
})

export const useSort = () => {
  const [{ direction, by }, setSort] = useRecoilState(sortState)
  return [
    { direction, by },
    sort => {
      if (by === sort) {
        const newDirection = direction === 'asc' ? 'desc' : 'asc'
        setSort({ by: sort, direction: newDirection })
      } else {
        setSort({ by: sort, direction: 'asc' })
      }
    }
  ]
}

export const useItemsSelected = () => {
  return useRecoilState(itemsSelectedState)
}

export const useLastItemCheckedState = () => {
  return useRecoilState(lastItemCheckedState)
}

export const useCountItems = () => {
  return useRecoilState(countItemsState)
}

const useFilters = () => {
  return useRecoilState(filtersState)
}

export const useQueryVariables = () => {
  const { siteId } = useParams()
  const [sort] = useSort()
  const [filters] = useFilters()

  const variables = useMemo(
    () => ({
      sf_id: siteId,
      verbatim: filters.verbatim,
      created_start_at: filters.created_start_at ? filters.created_start_at.toUTCString() : '',
      created_end_at: filters.created_end_at ? filters.created_end_at.toUTCString() : '',
      sort_by: sort.by,
      sort_direction: sort.direction
    }),
    [siteId, sort, filters]
  )

  return variables
}

export default useFilters
